import React from 'react';
import { CombinedAnimation } from './CombinedAnimation';

// Split Layout Player - Now renders CombinedAnimation directly without Remotion Player
// This removes letterboxing as the component fills 100% of its container
export const SplitLayoutPlayer = ({ className }) => {
    return (
        <div
            className={className}
            style={{
                width: '100%',
                height: '100%',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <CombinedAnimation />
        </div>
    );
};

// Re-export for backwards compatibility
export { CombinedAnimation } from './CombinedAnimation';
export { AnimatedBackground } from './AnimatedBackground';
export { TypewriterTitle, AnimatedSubtitle } from './TypewriterTitle';
export { FocusPulse } from './FocusPulse';
export { IntroSequence } from './IntroSequence';
